module.exports = __webpack_public_path__ + "img/upperCaseA.be7185c9.svg";